module.exports = __webpack_public_path__ + "static/media/mchat3.2cc4a78e.png";